import { shapeGeometry } from './framing';

// Where the logo's quick spots put it, for the shape being exported. Positions are the logo's
// CENTRE as fractions of the finished frame — the numbers brand_logo.placement burns with.
// "On the picture" uses the corners of the picture itself (in Vertical · Blur that is the
// sharp band in the middle); "In the frame" uses the corners of the whole frame.

export const LOGO_SPOTS = [
  { key: 'tl', label: '↖', title: 'Top left' },
  { key: 'tr', label: '↗', title: 'Top right' },
  { key: 'c', label: '◎', title: 'Center' },
  { key: 'bl', label: '↙', title: 'Bottom left' },
  { key: 'br', label: '↘', title: 'Bottom right' },
];

export const LOGO_BACKDROPS = [
  { key: 'none', label: 'None' },
  { key: 'dark', label: 'Dark' },
  { key: 'light', label: 'Light' },
];

/** Gap between the logo and the edge, as a fraction of the frame width. */
export const LOGO_MARGIN = 0.035;

/** The picture's box inside the frame ({left, top, w, h} fractions), for a shape. */
export const pictureBox = (shape, sourceAspect) => {
  const { output, picture } = shapeGeometry(shape, sourceAspect);
  if (picture >= output) {
    const h = output / picture;
    return { left: 0, top: (1 - h) / 2, w: 1, h };
  }
  const w = picture / output;
  return { left: (1 - w) / 2, top: 0, w, h: 1 };
};

/**
 * The centre (x, y) for a quick spot. `logoAspect` is the logo's width / height (with its
 * backdrop), `size` its width as a fraction of the frame width.
 */
export const spotPosition = (spot, { shape, sourceAspect, on = 'picture', size, logoAspect }) => {
  const { output } = shapeGeometry(shape, sourceAspect);
  const box = on === 'frame' ? { left: 0, top: 0, w: 1, h: 1 } : pictureBox(shape, sourceAspect);
  const lw = size;
  const lh = (size * output) / Math.max(logoAspect || 1, 0.01);   // logo height, as a fraction of frame height
  const mx = LOGO_MARGIN;
  const my = LOGO_MARGIN * output;                                // the same gap in pixels, vertically
  const left = box.left + mx + lw / 2;
  const right = box.left + box.w - mx - lw / 2;
  const top = box.top + my + lh / 2;
  const bottom = box.top + box.h - my - lh / 2;
  const cx = box.left + box.w / 2;
  const cy = box.top + box.h / 2;
  const pos = {
    tl: { x: left, y: top }, tr: { x: right, y: top },
    bl: { x: left, y: bottom }, br: { x: right, y: bottom },
    c: { x: cx, y: cy },
  }[spot] || { x: cx, y: cy };
  const clamp = (n, half) => Math.min(Math.max(n, half), 1 - half);
  return { x: clamp(pos.x, lw / 2), y: clamp(pos.y, Math.min(lh / 2, 0.5)) };
};

/** The backdrop's padding in the logo's own pixels — brand_logo.backdrop_padding. */
export const backdropPad = (w, h) => Math.max(4, Math.round(0.2 * Math.min(w, h)));
